import { Fragment, type FunctionComponent } from "react";
import { onlineOrder0 } from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import dayjs from "dayjs";
import { LL0 } from "@/react/core/I18nService.tsx";
import { LL3 } from "@/react/core/I18nCurrency.tsx";

interface ViewOrderDetailProps {
  onClose?: () => void;
}

const ViewOrderDetail: FunctionComponent<ViewOrderDetailProps> = ({ onClose }) => {
  return (
    <div className="min-w-[300px] max-w-[550px] h-full flex flex-col bg-white p-4 gap-2">
      <div className="flex justify-end">
        <img src="/icon-close-popup-icon--grey@2x.png" className="w-[18px] h-[18px]" alt="" onClick={onClose} />
      </div>
      <div className="flex flex-col gap-2 h-full no-scrollbar overflow-y-auto">
        <div className="flex text-[18px]">
          <div className="flex-1 font-bold text-[#1e1e23]">{LL0().onlineOrder.delivery()} #123</div>
          <div className="font-bold text-[#1e1e23]">{dayjs.unix(onlineOrder0()?.date || 0).format('hh:mmA')}</div>
        </div>
        <div className="flex flex-col gap-0.5">
          <div className="text-[14px]">{LL0().customer.name()}: {onlineOrder0()?.customerRaw?.name || ''}</div>
          <div className="text-[14px]">{LL0().customer.phone()}: {onlineOrder0()?.customerRaw?.phone || ''}</div>
          <div className="text-[14px] w-full break-words">{LL0().customer.address()}: {onlineOrder0()?.customerRaw?.address || ''}</div>
          {onlineOrder0()?.note &&
            <div className="text-[14px]">{LL0().article.note()}: {onlineOrder0()?.note || ''}</div>
          }
        </div>
        <div className="grid grid-cols-[8fr_2fr_3fr_3fr] w-full text-[#1e1e23]">
          <div className="border border-t-[2px] border-b-[2px] border-r-0 border-l-0 font-bold">{LL0().printing.product()}</div>
          <div className="text-center border border-t-[2px] border-b-[2px] border-r-0 border-l-0 font-bold">{LL0().printing.quantity()}</div>
          <div className="text-right border border-t-[2px] border-b-[2px] border-r-0 border-l-0 font-bold">{LL0().printing.price()}</div>
          <div className="text-end border border-t-[2px] border-b-[2px] border-r-0 border-l-0 font-bold">{LL0().printing.sum()}</div>
          <div className="col-span-4 h-2"></div>
          {onlineOrder0()?.items?.filter(item => item.quantity !== 0).map((item, index) => (
            <Fragment key={index}>
              <div className="break-words">{item.id}. {item.name}</div>
              <div className="text-center">{item.quantity}</div>
              <div className="text-right">{LL3().format.currency(item.price || 0)}</div>
              <div className="text-end">{LL3().format.currency(item.vPrice || 0)}</div>
              {item?.modifiers.length > 0 && item?.modifiers.map((m, _index) => (
                <Fragment key={_index}>
                  <div className="pl-2 break-words">*{m.name}</div>
                  <div className="text-center">{m.quantity}</div>
                  <div className="text-right">{LL3().format.currency(m.price || 0)}</div>
                  <div className="text-end">{LL3().format.currency(m.vPrice || 0)}</div>
                </Fragment>
              ))}
            </Fragment>
          ))}
        </div>
        <div className="w-full h-[1px] bg-black"/>
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div className="">{LL0().printing.subTotal()}</div>
            <div className="">{LL3().format.currency(onlineOrder0()?.vSubTotal || 0)}</div>
          </div>
          {Object.entries(onlineOrder0()?.vTaxSum || {}).map(([key, taxValue], index) => (
            <div key={index} className="flex justify-between items-center">
              <div className="">{LL0().printing.tax()} ({key}%)</div> {/* Hiển thị khóa 14.975 */}
              <div className="">{LL3().format.currency(taxValue.tax || 0)}</div> {/* Hiển thị giá trị thuế */}
            </div>
          ))}
        </div>
        <div className="w-full h-[1px] bg-black" />
        <div className="flex justify-between items-center font-bold">
          <div className="">{LL0().printing.total()}</div>
          <div className="">{LL3().format.currency(onlineOrder0()?.vTotal || 0)}</div>
        </div>
      </div>
    </div>
  )
}

export default ViewOrderDetail;